import React from 'react';

export type ColoredShareIconProps = {
    color: string;
};

const ColoredShareIcon = ({ color }: ColoredShareIconProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style={{ fill: color }}>
            <g fill="none" fillRule="evenodd">
                <g fillRule="nonzero">
                    <g>
                        <path style={{ fill: color }} fillOpacity="0" d="M0 0H24V24H0z" />
                        <path
                            style={{ fill: color }}
                            d="M12 3c.552 0 1 .448 1 1s-.448 1-1 1H6c-.552 0-1 .448-1 1v12c0 .552.448 1 1 1h12c.552 0 1-.448 1-1v-6c0-.552.448-1 1-1s1 .448 1 1v6c0 1.657-1.343 3-3 3H6c-1.657 0-3-1.343-3-3V6c0-1.657 1.343-3 3-3zm8 0c.552 0 1 .448 1 1v4c0 .552-.448 1-1 1s-1-.448-1-1V6.42l-6.29 6.28c-.188.19-.443.296-.71.296-.267 0-.522-.107-.71-.296-.19-.188-.296-.443-.296-.71 0-.267.107-.522.296-.71L17.58 5H16c-.552 0-1-.448-1-1s.448-1 1-1z"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};
export default ColoredShareIcon;
